// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: PqphFJZmPfQi
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateStateOnChangeProp,
  generateStateValueProp,
  hasVariant,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import Sidebar from "../../Sidebar"; // plasmic-import: NdFBK2CrJIH5/component
import NewSelectState from "../../NewSelectState"; // plasmic-import: qJ5gCB8LACfk/component
import { useScreenVariants as useScreenVariantseuyRl26Gw8Ft } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: EuyRl26Gw8Ft/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicViewDebtorMasterUser.module.css"; // plasmic-import: PqphFJZmPfQi/css
import image16ODavTq3D1X0 from "./images/image16.png"; // plasmic-import: oDav-TQ3d1x0/picture

createPlasmicElementProxy;

export const PlasmicViewDebtorMasterUser__VariantProps = new Array();

export const PlasmicViewDebtorMasterUser__ArgProps = new Array();

const $$ = {};

function PlasmicViewDebtorMasterUser__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "debtorName.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "email.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "phoneNumber.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "address1.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "city.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "zip.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "creditorName.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "debtSituation.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "productName.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantseuyRl26Gw8Ft()
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <Sidebar
            data-plasmic-name={"sidebar"}
            data-plasmic-override={overrides.sidebar}
            className={classNames("__wab_instance", sty.sidebar)}
          />

          <div
            data-plasmic-name={"vertStack"}
            data-plasmic-override={overrides.vertStack}
            className={classNames(projectcss.all, sty.vertStack)}
          >
            <div className={classNames(projectcss.all, sty.freeBox__t5HHg)}>
              <Stack__
                as={"div"}
                data-plasmic-name={"invoiceDetails"}
                data-plasmic-override={overrides.invoiceDetails}
                hasGap={true}
                className={classNames(projectcss.all, sty.invoiceDetails)}
              >
                <div className={classNames(projectcss.all, sty.freeBox__xfOxy)}>
                  <div
                    data-plasmic-name={"title4"}
                    data-plasmic-override={overrides.title4}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title4
                    )}
                  >
                    {"Debtor Details"}
                  </div>
                  <div
                    data-plasmic-name={"createSettlementButton"}
                    data-plasmic-override={overrides.createSettlementButton}
                    className={classNames(
                      projectcss.all,
                      sty.createSettlementButton
                    )}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__hu4EQ
                      )}
                    >
                      {hasVariant(globalVariants, "screen", "medium")
                        ? "Create Settlement"
                        : "Create Settlement"}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"createSubscriptionButton"}
                    data-plasmic-override={overrides.createSubscriptionButton}
                    className={classNames(
                      projectcss.all,
                      sty.createSubscriptionButton
                    )}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__d9UVm
                      )}
                    >
                      {hasVariant(globalVariants, "screen", "medium")
                        ? "Create Payment Plan"
                        : "Create Payment Plan"}
                    </div>
                  </div>
                </div>
                <div className={classNames(projectcss.all, sty.freeBox___7X0S)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__v8NEg
                    )}
                  >
                    {"Debtor Name"}
                  </div>
                  <input
                    data-plasmic-name={"debtorName"}
                    data-plasmic-override={overrides.debtorName}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.debtorName
                    )}
                    onChange={async (...eventArgs) => {
                      (e => {
                        generateStateOnChangeProp($state, [
                          "debtorName",
                          "value"
                        ])(e.target.value);
                      }).apply(null, eventArgs);
                    }}
                    placeholder={"Full Name"}
                    ref={ref => {
                      $refs["debtorName"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={
                      generateStateValueProp($state, ["debtorName", "value"]) ??
                      ""
                    }
                  />
                </div>
                <div
                  data-plasmic-name={"debtorNameError"}
                  data-plasmic-override={overrides.debtorNameError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.debtorNameError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Debtor Name is a required field"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Debtor Name is a required field"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__p1Wiw)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__k58M
                    )}
                  >
                    {"Amount of unpaid debt"}
                  </div>
                  <div
                    data-plasmic-name={"debtAmount"}
                    data-plasmic-override={overrides.debtAmount}
                    className={classNames(projectcss.all, sty.debtAmount)}
                  />
                </div>
                <div
                  data-plasmic-name={"debtAmountError"}
                  data-plasmic-override={overrides.debtAmountError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.debtAmountError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Amount of debt is a required field"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Amount of debt is a required field"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__noMfY)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__oL3P7
                    )}
                  >
                    {
                      "Delinquency Date (when your customer's payment was originally due)"
                    }
                  </div>
                  <div
                    data-plasmic-name={"debtAge"}
                    data-plasmic-override={overrides.debtAge}
                    className={classNames(projectcss.all, sty.debtAge)}
                  />
                </div>
                <div
                  data-plasmic-name={"debtAgeError"}
                  data-plasmic-override={overrides.debtAgeError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.debtAgeError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Age of debt is a required field"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Delinquency Date is a required field"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__vqzqh)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__ywaAa
                    )}
                  >
                    {"Debtor Phone Number"}
                  </div>
                  <input
                    data-plasmic-name={"phoneNumber"}
                    data-plasmic-override={overrides.phoneNumber}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.phoneNumber
                    )}
                    onChange={async (...eventArgs) => {
                      (e => {
                        generateStateOnChangeProp($state, [
                          "phoneNumber",
                          "value"
                        ])(e.target.value);
                      }).apply(null, eventArgs);
                    }}
                    placeholder={``}
                    ref={ref => {
                      $refs["phoneNumber"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={
                      generateStateValueProp($state, [
                        "phoneNumber",
                        "value"
                      ]) ?? ""
                    }
                  />
                </div>
                <div
                  data-plasmic-name={"debtorPhoneError"}
                  data-plasmic-override={overrides.debtorPhoneError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.debtorPhoneError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"At least one phone number or email is required"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"At least one phone number or email is required"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__pPNdY)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__vgtB3
                    )}
                  >
                    {"Debtor Email"}
                  </div>
                  <input
                    data-plasmic-name={"email"}
                    data-plasmic-override={overrides.email}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.email
                    )}
                    onChange={async (...eventArgs) => {
                      (e => {
                        generateStateOnChangeProp($state, ["email", "value"])(
                          e.target.value
                        );
                      }).apply(null, eventArgs);
                    }}
                    placeholder={``}
                    ref={ref => {
                      $refs["email"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={
                      generateStateValueProp($state, ["email", "value"]) ?? ""
                    }
                  />
                </div>
                <div
                  data-plasmic-name={"debtorEmailError"}
                  data-plasmic-override={overrides.debtorEmailError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.debtorEmailError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"At least one phone number or email is required"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"At least one phone number or email is required"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__tmNy3)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__qqmXc
                    )}
                  >
                    {"Name of the product or service delivered to the debtor"}
                  </div>
                  <input
                    data-plasmic-name={"productName"}
                    data-plasmic-override={overrides.productName}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.productName
                    )}
                    onChange={async (...eventArgs) => {
                      (e => {
                        generateStateOnChangeProp($state, [
                          "productName",
                          "value"
                        ])(e.target.value);
                      }).apply(null, eventArgs);
                    }}
                    placeholder={``}
                    ref={ref => {
                      $refs["productName"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={
                      generateStateValueProp($state, [
                        "productName",
                        "value"
                      ]) ?? ""
                    }
                  />
                </div>
                <div
                  data-plasmic-name={"productError"}
                  data-plasmic-override={overrides.productError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.productError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Age of debt is a required field"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Name of the product or service is required"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__vecty)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__sbrh8
                    )}
                  >
                    {"Creditor Name (who the debt is owed to)"}
                  </div>
                  <input
                    data-plasmic-name={"creditorName"}
                    data-plasmic-override={overrides.creditorName}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.creditorName
                    )}
                    onChange={async (...eventArgs) => {
                      (e => {
                        generateStateOnChangeProp($state, [
                          "creditorName",
                          "value"
                        ])(e.target.value);
                      }).apply(null, eventArgs);
                    }}
                    placeholder={``}
                    ref={ref => {
                      $refs["creditorName"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={
                      generateStateValueProp($state, [
                        "creditorName",
                        "value"
                      ]) ?? ""
                    }
                  />
                </div>
                <div
                  data-plasmic-name={"creditorNameError"}
                  data-plasmic-override={overrides.creditorNameError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.creditorNameError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Age of debt is a required field"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Creditor Name is a required field"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__nywvd)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__ydAXk
                    )}
                  >
                    {"Debtor's Address or Location (if known)"}
                  </div>
                  <input
                    data-plasmic-name={"address1"}
                    data-plasmic-override={overrides.address1}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.address1
                    )}
                    onChange={async (...eventArgs) => {
                      (e => {
                        generateStateOnChangeProp($state, [
                          "address1",
                          "value"
                        ])(e.target.value);
                      }).apply(null, eventArgs);
                    }}
                    placeholder={"Address Line"}
                    ref={ref => {
                      $refs["address1"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={
                      generateStateValueProp($state, ["address1", "value"]) ??
                      ""
                    }
                  />

                  <input
                    data-plasmic-name={"city"}
                    data-plasmic-override={overrides.city}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.city
                    )}
                    onChange={async (...eventArgs) => {
                      (e => {
                        generateStateOnChangeProp($state, ["city", "value"])(
                          e.target.value
                        );
                      }).apply(null, eventArgs);
                    }}
                    placeholder={"City"}
                    ref={ref => {
                      $refs["city"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={
                      generateStateValueProp($state, ["city", "value"]) ?? ""
                    }
                  />

                  <NewSelectState
                    data-plasmic-name={"state"}
                    data-plasmic-override={overrides.state}
                    className={classNames("__wab_instance", sty.state)}
                  />

                  <input
                    data-plasmic-name={"zip"}
                    data-plasmic-override={overrides.zip}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.zip
                    )}
                    onChange={async (...eventArgs) => {
                      (e => {
                        generateStateOnChangeProp($state, ["zip", "value"])(
                          e.target.value
                        );
                      }).apply(null, eventArgs);
                    }}
                    placeholder={"ZIP"}
                    ref={ref => {
                      $refs["zip"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={
                      generateStateValueProp($state, ["zip", "value"]) ?? ""
                    }
                  />
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__lPQk)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__t12G8
                    )}
                  >
                    {"Debtor's Date of Birth (if known)"}
                  </div>
                  <div
                    data-plasmic-name={"dob"}
                    data-plasmic-override={overrides.dob}
                    className={classNames(projectcss.all, sty.dob)}
                  />
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__uPkV)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__atO1K
                    )}
                  >
                    {"Download Files"}
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.freeBox___3RxM)}
                  >
                    <div
                      className={classNames(projectcss.all, sty.freeBox__ymJub)}
                    >
                      <div
                        data-plasmic-name={"downloadFiles"}
                        data-plasmic-override={overrides.downloadFiles}
                        className={classNames(
                          projectcss.all,
                          sty.downloadFiles
                        )}
                      >
                        <PlasmicImg__
                          data-plasmic-name={"img"}
                          data-plasmic-override={overrides.img}
                          alt={""}
                          className={classNames(sty.img)}
                          displayHeight={"auto"}
                          displayMaxHeight={"none"}
                          displayMaxWidth={"100%"}
                          displayMinHeight={"0"}
                          displayMinWidth={"0"}
                          displayWidth={"12%"}
                          loading={"lazy"}
                          src={{
                            src: image16ODavTq3D1X0,
                            fullWidth: 128,
                            fullHeight: 128,
                            aspectRatio: undefined
                          }}
                        />

                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__uCjlI
                          )}
                        >
                          {"Download Files"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__szBt5)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__wxl5Z
                    )}
                  >
                    {"Description of the Debt Situation"}
                  </div>
                  <textarea
                    data-plasmic-name={"debtSituation"}
                    data-plasmic-override={overrides.debtSituation}
                    className={classNames(
                      projectcss.all,
                      projectcss.textarea,
                      sty.debtSituation
                    )}
                    onChange={async (...eventArgs) => {
                      (e => {
                        generateStateOnChangeProp($state, [
                          "debtSituation",
                          "value"
                        ])(e.target.value);
                      }).apply(null, eventArgs);
                    }}
                    ref={ref => {
                      $refs["debtSituation"] = ref;
                    }}
                    value={
                      generateStateValueProp($state, [
                        "debtSituation",
                        "value"
                      ]) ?? ""
                    }
                  />
                </div>
              </Stack__>
              <div className={classNames(projectcss.all, sty.freeBox__kretP)}>
                <div
                  data-plasmic-name={"creditorName3"}
                  data-plasmic-override={overrides.creditorName3}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.creditorName3
                  )}
                >
                  {"Creditor: Wilfley LLC "}
                </div>
                <div
                  data-plasmic-name={"step1Stack"}
                  data-plasmic-override={overrides.step1Stack}
                  className={classNames(projectcss.all, sty.step1Stack)}
                >
                  <div
                    data-plasmic-name={"creditorName32"}
                    data-plasmic-override={overrides.creditorName32}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.creditorName32
                    )}
                  >
                    {"1."}
                  </div>
                  <div
                    data-plasmic-name={"step1"}
                    data-plasmic-override={overrides.step1}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.step1
                    )}
                  >
                    {"Click"}
                  </div>
                  <div
                    data-plasmic-name={"createEmail"}
                    data-plasmic-override={overrides.createEmail}
                    className={classNames(projectcss.all, sty.createEmail)}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__zgbUm
                      )}
                    >
                      {hasVariant(globalVariants, "screen", "medium")
                        ? "Create Email"
                        : "Create Email"}
                    </div>
                  </div>
                </div>
                <div
                  data-plasmic-name={"step2Stack"}
                  data-plasmic-override={overrides.step2Stack}
                  className={classNames(projectcss.all, sty.step2Stack)}
                >
                  <div
                    data-plasmic-name={"creditorName34"}
                    data-plasmic-override={overrides.creditorName34}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.creditorName34
                    )}
                  >
                    {"2."}
                  </div>
                  <div
                    data-plasmic-name={"step2"}
                    data-plasmic-override={overrides.step2}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.step2
                    )}
                  >
                    {"Link the email account with standard connection"}
                  </div>
                </div>
                <div
                  data-plasmic-name={"step3Stack"}
                  data-plasmic-override={overrides.step3Stack}
                  className={classNames(projectcss.all, sty.step3Stack)}
                >
                  <div
                    data-plasmic-name={"creditorName33"}
                    data-plasmic-override={overrides.creditorName33}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.creditorName33
                    )}
                  >
                    {"3."}
                  </div>
                  <div
                    data-plasmic-name={"step3"}
                    data-plasmic-override={overrides.step3}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.step3
                    )}
                  >
                    {"Click"}
                  </div>
                  <div
                    data-plasmic-name={"enrollDebtors"}
                    data-plasmic-override={overrides.enrollDebtors}
                    className={classNames(projectcss.all, sty.enrollDebtors)}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__kas8I
                      )}
                    >
                      {hasVariant(globalVariants, "screen", "medium")
                        ? "Create Email"
                        : "Enroll In Workflow"}
                    </div>
                  </div>
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__k6UeS)}>
                <div
                  data-plasmic-name={"creditorName2"}
                  data-plasmic-override={overrides.creditorName2}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.creditorName2
                  )}
                >
                  {"Creditor: Wilfley LLC "}
                </div>
                <div
                  data-plasmic-name={"sendCreditorPayout"}
                  data-plasmic-override={overrides.sendCreditorPayout}
                  className={classNames(projectcss.all, sty.sendCreditorPayout)}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text___9HUie
                    )}
                  >
                    {hasVariant(globalVariants, "screen", "medium")
                      ? "Create Payment Plan"
                      : "Set Pricing"}
                  </div>
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__ynOgL)}>
                <div
                  data-plasmic-name={"creditorName22"}
                  data-plasmic-override={overrides.creditorName22}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.creditorName22
                  )}
                >
                  {"Manage AI Communication Responses"}
                </div>
                <div
                  data-plasmic-name={"pauseAiResponses"}
                  data-plasmic-override={overrides.pauseAiResponses}
                  className={classNames(projectcss.all, sty.pauseAiResponses)}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text___6UrdK
                    )}
                  >
                    {hasVariant(globalVariants, "screen", "medium")
                      ? "Pause"
                      : "Pause"}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "sidebar",
    "vertStack",
    "invoiceDetails",
    "title4",
    "createSettlementButton",
    "createSubscriptionButton",
    "debtorName",
    "debtorNameError",
    "debtAmount",
    "debtAmountError",
    "debtAge",
    "debtAgeError",
    "phoneNumber",
    "debtorPhoneError",
    "email",
    "debtorEmailError",
    "productName",
    "productError",
    "creditorName",
    "creditorNameError",
    "address1",
    "city",
    "state",
    "zip",
    "dob",
    "downloadFiles",
    "img",
    "debtSituation",
    "creditorName3",
    "step1Stack",
    "creditorName32",
    "step1",
    "createEmail",
    "step2Stack",
    "creditorName34",
    "step2",
    "step3Stack",
    "creditorName33",
    "step3",
    "enrollDebtors",
    "creditorName2",
    "sendCreditorPayout",
    "creditorName22",
    "pauseAiResponses"
  ],

  sidebar: ["sidebar"],
  vertStack: [
    "vertStack",
    "invoiceDetails",
    "title4",
    "createSettlementButton",
    "createSubscriptionButton",
    "debtorName",
    "debtorNameError",
    "debtAmount",
    "debtAmountError",
    "debtAge",
    "debtAgeError",
    "phoneNumber",
    "debtorPhoneError",
    "email",
    "debtorEmailError",
    "productName",
    "productError",
    "creditorName",
    "creditorNameError",
    "address1",
    "city",
    "state",
    "zip",
    "dob",
    "downloadFiles",
    "img",
    "debtSituation",
    "creditorName3",
    "step1Stack",
    "creditorName32",
    "step1",
    "createEmail",
    "step2Stack",
    "creditorName34",
    "step2",
    "step3Stack",
    "creditorName33",
    "step3",
    "enrollDebtors",
    "creditorName2",
    "sendCreditorPayout",
    "creditorName22",
    "pauseAiResponses"
  ],

  invoiceDetails: [
    "invoiceDetails",
    "title4",
    "createSettlementButton",
    "createSubscriptionButton",
    "debtorName",
    "debtorNameError",
    "debtAmount",
    "debtAmountError",
    "debtAge",
    "debtAgeError",
    "phoneNumber",
    "debtorPhoneError",
    "email",
    "debtorEmailError",
    "productName",
    "productError",
    "creditorName",
    "creditorNameError",
    "address1",
    "city",
    "state",
    "zip",
    "dob",
    "downloadFiles",
    "img",
    "debtSituation"
  ],

  title4: ["title4"],
  createSettlementButton: ["createSettlementButton"],
  createSubscriptionButton: ["createSubscriptionButton"],
  debtorName: ["debtorName"],
  debtorNameError: ["debtorNameError"],
  debtAmount: ["debtAmount"],
  debtAmountError: ["debtAmountError"],
  debtAge: ["debtAge"],
  debtAgeError: ["debtAgeError"],
  phoneNumber: ["phoneNumber"],
  debtorPhoneError: ["debtorPhoneError"],
  email: ["email"],
  debtorEmailError: ["debtorEmailError"],
  productName: ["productName"],
  productError: ["productError"],
  creditorName: ["creditorName"],
  creditorNameError: ["creditorNameError"],
  address1: ["address1"],
  city: ["city"],
  state: ["state"],
  zip: ["zip"],
  dob: ["dob"],
  downloadFiles: ["downloadFiles", "img"],
  img: ["img"],
  debtSituation: ["debtSituation"],
  creditorName3: ["creditorName3"],
  step1Stack: ["step1Stack", "creditorName32", "step1", "createEmail"],
  creditorName32: ["creditorName32"],
  step1: ["step1"],
  createEmail: ["createEmail"],
  step2Stack: ["step2Stack", "creditorName34", "step2"],
  creditorName34: ["creditorName34"],
  step2: ["step2"],
  step3Stack: ["step3Stack", "creditorName33", "step3", "enrollDebtors"],
  creditorName33: ["creditorName33"],
  step3: ["step3"],
  enrollDebtors: ["enrollDebtors"],
  creditorName2: ["creditorName2"],
  sendCreditorPayout: ["sendCreditorPayout"],
  creditorName22: ["creditorName22"],
  pauseAiResponses: ["pauseAiResponses"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicViewDebtorMasterUser__ArgProps,
          internalVariantPropNames: PlasmicViewDebtorMasterUser__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicViewDebtorMasterUser__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicViewDebtorMasterUser";
  } else {
    func.displayName = `PlasmicViewDebtorMasterUser.${nodeName}`;
  }
  return func;
}

export const PlasmicViewDebtorMasterUser = Object.assign(
  // Top-level PlasmicViewDebtorMasterUser renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    sidebar: makeNodeComponent("sidebar"),
    vertStack: makeNodeComponent("vertStack"),
    invoiceDetails: makeNodeComponent("invoiceDetails"),
    title4: makeNodeComponent("title4"),
    createSettlementButton: makeNodeComponent("createSettlementButton"),
    createSubscriptionButton: makeNodeComponent("createSubscriptionButton"),
    debtorName: makeNodeComponent("debtorName"),
    debtorNameError: makeNodeComponent("debtorNameError"),
    debtAmount: makeNodeComponent("debtAmount"),
    debtAmountError: makeNodeComponent("debtAmountError"),
    debtAge: makeNodeComponent("debtAge"),
    debtAgeError: makeNodeComponent("debtAgeError"),
    phoneNumber: makeNodeComponent("phoneNumber"),
    debtorPhoneError: makeNodeComponent("debtorPhoneError"),
    email: makeNodeComponent("email"),
    debtorEmailError: makeNodeComponent("debtorEmailError"),
    productName: makeNodeComponent("productName"),
    productError: makeNodeComponent("productError"),
    creditorName: makeNodeComponent("creditorName"),
    creditorNameError: makeNodeComponent("creditorNameError"),
    address1: makeNodeComponent("address1"),
    city: makeNodeComponent("city"),
    state: makeNodeComponent("state"),
    zip: makeNodeComponent("zip"),
    dob: makeNodeComponent("dob"),
    downloadFiles: makeNodeComponent("downloadFiles"),
    img: makeNodeComponent("img"),
    debtSituation: makeNodeComponent("debtSituation"),
    creditorName3: makeNodeComponent("creditorName3"),
    step1Stack: makeNodeComponent("step1Stack"),
    creditorName32: makeNodeComponent("creditorName32"),
    step1: makeNodeComponent("step1"),
    createEmail: makeNodeComponent("createEmail"),
    step2Stack: makeNodeComponent("step2Stack"),
    creditorName34: makeNodeComponent("creditorName34"),
    step2: makeNodeComponent("step2"),
    step3Stack: makeNodeComponent("step3Stack"),
    creditorName33: makeNodeComponent("creditorName33"),
    step3: makeNodeComponent("step3"),
    enrollDebtors: makeNodeComponent("enrollDebtors"),
    creditorName2: makeNodeComponent("creditorName2"),
    sendCreditorPayout: makeNodeComponent("sendCreditorPayout"),
    creditorName22: makeNodeComponent("creditorName22"),
    pauseAiResponses: makeNodeComponent("pauseAiResponses"),
    // Metadata about props expected for PlasmicViewDebtorMasterUser
    internalVariantProps: PlasmicViewDebtorMasterUser__VariantProps,
    internalArgProps: PlasmicViewDebtorMasterUser__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicViewDebtorMasterUser;
/* prettier-ignore-end */
